import { h, ComponentChild } from 'preact'
import SearchResult from './SearchResult'
import Phrase from '../../../libs/translationsUtils/phrase'
import {
  Hit,
  ZendeskHit,
  GetItemPropsFn,
  SearchResults,
  SearchType,
  TopicClickedEvent,
  TopicClickedGoogleAnalyticsEvent,
  isCommunityResult,
  EventHit, isCommunityResultEvent, SalesforceHit, SkilljarHit
} from './'

interface Props {
  title?: ComponentChild,
  searchMetadata: SearchResults,
  hits: Array<EventHit|Hit|ZendeskHit|SalesforceHit|SkilljarHit>,
  highlightedIndex: number,
  getItemProps: GetItemPropsFn,
  previousResultsCount: number,
  type: SearchType,
  viewAllUrl: string,
  setHighlightedIndex: (idx: number | null) => void
}

const eventTrackerInfo = (hit: EventHit|Hit|ZendeskHit|SalesforceHit|SkilljarHit, type: SearchType, idx: number) => {
  let resultType = 'Topic Clicked'
  if (type === 'zendesk') {
    resultType = 'Yip.ZendeskGuideResultClicked'
  }
  if (type === 'salesforce') {
    resultType = 'Yip.SalesforceKBResultClicked'
  }
  // to implement skilljar

  let track: TopicClickedEvent = {
    type: resultType,
    topic_url: hit.topic_url || '',
    click_source: 'live-search',
    topic_position: idx,
    topic_title: hit.title,
    topic_topic_type: isCommunityResult(hit) ? hit.content_type : type
  }
  if (isCommunityResult(hit) && !isCommunityResultEvent(hit)) {
    track.category_id = hit.forum
    track.category_title = hit.forum_title
  }

  let gaEvents: TopicClickedGoogleAnalyticsEvent = {
    eventCategory: 'Live Search',
    eventAction: 'Topic Clicked',
    eventLabel: {
      Link: hit.topic_url || '',
      Position: idx,
      Type: isCommunityResult(hit) ? hit.content_type : type
    }
  }

  return {
    track,
    gaEvents
  }
}

const SearchResultsSection = ({
  title,
  searchMetadata,
  hits,
  highlightedIndex,
  getItemProps,
  previousResultsCount,
  type,
  viewAllUrl,
  setHighlightedIndex
}: Props) => {
  if (!hits.length) return null
  return (
    <div onMouseLeave={() => { setHighlightedIndex(null) }}>
      {
        title ? (
          <div className='algolia-search-results-section__title'>
            <span class='algolia-search-results-section__title-label'>{title}</span>
            {
              viewAllUrl !== '' ? (
                <a className='algolia-search-results-section__title-link' href={viewAllUrl}>
                  <Phrase p='live.search.view.all' />
                </a>
              ) : null
            }
          </div>
        ) : ''
      }
      <ul className='algolia-search-results'>
        {
          hits.map((hit, index) => {
            return Object.assign({}, hit, {
              position: searchMetadata.hitsPerPage * searchMetadata.page + index + 1,
              queryID: searchMetadata.queryID
            })
          }).map((hit, defaultIndex) => {
            const index = defaultIndex + previousResultsCount
            hit.topic_url = hit.topic_url || hit.url

            const eventTrackers = eventTrackerInfo(hit, type, defaultIndex + 1)

            return <SearchResult
              key={hit.objectID}
              isHighlited={highlightedIndex === index}
              hit={hit}
              track={eventTrackers.track}
              type={type}
              gaEvents={eventTrackers.gaEvents}
              index={index}
              getItemProps={getItemProps}
            />
          })
        }
      </ul>
    </div>
  )
}

export default SearchResultsSection
